<template>
    <div :class="{ 'user-detail-wrapper': !crm }">
    <div v-if="!crm" class="header" :class="{liveChat : $route.path === '/page-inbox'}">
      <div class="custom-tabs">
        <div class="custom-tab" :class="{ active: active_customerDetailTab === 'userDetails' }" @click="active_customerDetailTab = 'userDetails'">
          Customer Info
        </div>
        <div class="custom-tab" :class="{ active: active_customerDetailTab === 'actions' }" @click="openActionsTab">
          Actions
        </div>
      </div>
    </div>
    <div class="customer-info" :class="{ crm }">
      <div v-show="active_customerDetailTab === 'userDetails'">
        <div v-if="!crm" class="customer-details-header">
          <div class="flex-box">
            <CustomerConnectedChannel :customer="customerForDisplay" placement="customerDetails" />
          </div>
          <div class="cust-margin">
            <div class="flex-center">
              <p class="cust-title ion-no-margin paddingBottom" :title="newName">{{ newName }} </p>
            </div>
            <div v-if="activeCustomer.whatsapp_username" class="flex-center" style="margin-bottom: 5px">
              <p class="flex-center sub-title ion-no-margin">{{ '~ ' + activeCustomer.whatsapp_username }}</p>
              <VIcon style="cursor: pointer; color: var(--ion-color-primary)" name="copy-2-line" class="icon" @click="copyToClipboard(activeCustomer.whatsapp_username)"></VIcon>
            </div>
            <div class="flex-center">
              <p class="number_container flex-center sub-title ion-no-margin">{{ displayMobileNumber }}</p>
              <VIcon v-if="activeCustomer.mobile && activeCustomer.mobile !== 'unrecorded' && activeCustomer.mobile !== 'None'" style="cursor: pointer; color: var(--ion-color-primary); padding-left: 5px;" name="copy-2-line" class="icon" @click="copyToClipboard(displayMobileNumber)"></VIcon>
            </div>
          </div>
          <div class="text-center customer-options">
            <div v-show="!activeCustomer.retarget" @click="confirmResolveBttn = true" class="optionsBttn cursorPointer" :class="{ 'resolving': isResolving }" :style="{ 'pointer-events': isResolving ? 'none' : 'auto' }">
              <img alt="resolved" src="@/resources/images/chatbubble-outline.svg" class="icons" />
              <p class="ion-no-margin text">{{ isResolving ? 'Resolving...' : 'Mark as resolved' }}</p>
            </div>
            <div v-show="activeCustomer.retarget" class="optionsBttn cursorPointer">
              <img alt="resolved" src="@/resources/images/chatbubble-outline.svg" class="icons" />
              <p class="ion-no-margin text">Resolved</p>
            </div>
            <div @click="followUpBttn()" class="cursorPointer">
              <VIcon :name="followupTag ? 'star-solid' : 'star-line'" :size="-4" class="icons"></VIcon>
              <p class="ion-no-margin text"> {{ followupTag ? 'Unfollow' : 'Follow-up' }}</p>
            </div>
            <div class="cursorPointer" v-if="activeCustomer.assigned_to != null && activeCustomer.followup == true"  @click="() => $emit('sendReminder')">
              <VIcon name="notification-on-line" :size="-4" class="icons"></VIcon>
              <p class="ion-no-margin text">Set Reminder</p>
            </div>
          </div>
          <div v-if="activeCustomer?.all_platforms?.length > 0" class="flexBox interaction_container">
            <span class="sub-title" style="width: 40%">Interacted on</span>
            <div class="filterAssigned">
              <span class="sub-title text-right">Marketing Opt-in Status</span>
            </div>
          </div>
          <div v-for="(channel, index) in sortedPlatforms" :key="index" class="flexBox interaction_container" style="border-top: 0px; padding-top: 0px;">
            <div class="filterAssigned" style="width: 40%">
              <div class="img-sections" @click="() => $router.push('/page-inbox?conversation=' + channel.conversation_key)">
                <img v-if="channels[channel.platform]" :src="channels[channel.platform].icon" class="channelIcon" alt="channels" />
                <span v-if="channels[channel.platform]" class="title">{{ channels[channel.platform].name }}</span>
              </div>
            </div>
            <div class="filterAssigned text-right">
              <div class="flex-start ion-align-items-center customerInfo optin-status-tag optin-nostatus" v-if="channel.marketing_opt_in_state === 0">
                <img src="@/resources/images/marketing-optin-nostatus.svg" alt="no_status"/>
                No status
              </div>
              <div class="flex-start ion-align-items-center customerInfo optin-status-tag optin-subscribed" v-if="channel.marketing_opt_in_state === 1">
                <img src="@/resources/images/marketing-optin-subscribed.svg" alt="no_status"/>
                Subscribed
              </div>
              <div class="flex-start ion-align-items-center customerInfo optin-status-tag optin-unsubscribed" v-if="channel.marketing_opt_in_state === -1">
                <img src="@/resources/images/marketing-optin-unsubscribed.svg"  alt="no_status"/>
                Unsubscribed
              </div>
            </div>
          </div>
          <div v-if="agentReAssignmentAllowed && !crm" class="agent-details">
            <div v-if="activeCustomer.assigned_to != null" class="flexBox">
              <div class="flexBox">
                <div v-if="activeCustomer.assigned_to.picture != null" class="agent-img">
                  <img :src="checkIfThereIsNoLogoThenShowTransparentImage(activeCustomer.assigned_to.picture)" alt="logo" class="agent-img-inner" />
                </div>
                <img alt="agent-name" v-if="activeCustomer.assigned_to.picture == null" src="@/resources/images/default-customer.svg" class="agent-img" />
                <div class="description">
                  <p class="title ion-no-margin">Assigned Agent</p>
                  <h2 class="title ion-no-margin" v-if="activeCustomer.assigned_to != null" :title="activeCustomer.assigned_to.name">{{ activeCustomer.assigned_to.name }} </h2>
                </div>
              </div>
              <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Re-assign" @click="() => $emit('reassign')"></VButton>
            </div>
            <div v-else>
              <div class="flexBox">
                <div class="flexBox">
                  <img alt="agent-name" src="@/resources/images/default-customer.svg" class="agent-img" />
                  <div class="description">
                    <p class="title ion-no-margin">Assign Agent</p>
                  </div>
                </div>
                <VButton v-if="activeCustomer.assigned_to == null" class="vvd-btn-primary" connotation="cta" appearance="filled" label="Assign" @click="() => $emit('reassign')"></VButton>
              </div>
            </div>
          </div>
         </div>

        <div class="allAccordians">
          <!-- Customer details -->
          <div class="custom_mrg_bottom customerDetails">
            <div v-if="!crm" class="accordion-header" @click="toggleAccordion('customerDetails')">
              <span class="customer-info-title">Customer details</span>
              <VIcon :name="openAccordions.customerDetails ? 'chevron-up-line' : 'chevron-down-line'" :size="-5" />
            </div>
            <transition name="accordion-slide">
              <div v-if="crm || openAccordions.customerDetails" class="list-container">
              <div v-if="spinnerLoader" class="spinner spinnerContainer">
                <VProgressRing class="vvd-spinner" connotation="cta" indeterminate />
              </div>
              <div v-else class="cust-margin">
                <template v-if="crm">
                  <div class="cust-brdr">
                  <div class="cust-brdr infoContainer">
                    <div>
                      <CustomerConnectedChannel :customer="customerForDisplay" :isEditCustomer="true" @customer_image_updated="handleCustomerImage" placement="custom_edit_details" />
                    </div>
                    <div>
                      <div class="flex-between gap5P" style="margin-bottom: 7px;">
                        <h2 class="modal-header ion-no-margin">{{ newName }} </h2>
                        <VIcon v-if="activeCustomer.gender == 'male' || activeCustomer.gender == 'female'" :name="activeCustomer.gender == 'male' ? maleOutline : femaleOutline" class="genderIcon"></VIcon>                       </div>
                      <div v-if="activeCustomer.whatsapp_username" class="flex-start" style="margin-bottom: 7px;">
                        <p class="flex-center sub-title ion-no-margin">{{ '~ ' + activeCustomer.whatsapp_username }}</p>
                        <VIcon style="cursor: pointer; padding-left: 5px; color: var(--ion-color-primary)" name="copy-2-line" class="icon" @click="copyToClipboard(activeCustomer.whatsapp_username)"></VIcon>
                      </div>
                      <div class="flex-start alignCenter">
                        <p class="number_container flex-center sub-title ion-no-margin">{{ displayMobileNumber }}</p>
                         <VIcon v-if="activeCustomer.mobile && activeCustomer.mobile !== 'unrecorded' && activeCustomer.mobile !== 'None'" style="cursor: pointer; padding-left: 5px; color: var(--ion-color-primary)" name="copy-2-line" class="icon" @click="copyToClipboard(displayMobileNumber)"></VIcon>
                      </div>
                    </div>
                  </div>

                 <div>
                    <div class="customer-list" style="border-bottom: 0px; margin-bottom: 10px;">
                      <span class="title ion-no-margin flex100P">Interacted on</span>
                      <span class="title ion-no-margin flex100P text-right">Marketing Opt-in Status</span>
                    </div>
                    <div v-for="(channel, index) in sortedPlatforms" :key="index" class="customer-list" style="padding-top: 0px; border-bottom: 0px;">
                      <div class="filterAssigned flex100P conversation_channel" style="padding-top: 0px;">
                        <div
                          class="channel-row"
                        >
                          <div class="channel-info" @click="$router.push({ path: '/page-inbox', query: { conversation: channel.conversation_key } })">
                            <span class="tooltip_container">
                              <img v-if="channels[channel.platform]" :src="channels[channel.platform].icon" class="channel-icon" />
                              <span class="tooltip_text left" style="width: 86px">Go to Chat</span>
                            </span>
                            <span class="channel-name">
                              {{ channels[channel.platform]?.name }}
                            </span>
                          </div>
                          <div class="channel-actions" v-if="(channel.platform === 'whatsapp' && String(activeCustomer?.pageid) !== String(whatsAppSocialData?.id) && activeCustomer.channel == 'whatsapp') || (channel.platform === 'googlercs' && String(activeCustomer?.pageid) !== String(googlercsSocialData?.id) && activeCustomer.channel == 'googlercs') || (channel.platform === 'sms' && String(activeCustomer?.pageid) !== String(smsSocialData?.id) && activeCustomer.channel == 'sms')" @click="$router.push({ path: '/page-inbox', query: { conversation: channel.conversation_key } })">
                            <HelpTooltip 
                              :iconImage="conversationDeletedIcon" 
                            >
                              Conversation's Channel has been disconnected
                            </HelpTooltip>
                          </div>
                        </div>
                      </div>
                      <div class="filterAssigned flex100P text-right" style="padding-top: 0px; flex-direction: row-reverse;">
                        <div class="customerInfo optin-status-tag optin-nostatus" v-if="channel.marketing_opt_in_state === 0">
                          <img src="@/resources/images/marketing-optin-nostatus.svg" alt="no_status" class=""/>
                          No status
                        </div>
                        <div class="customerInfo optin-status-tag optin-subscribed" v-if="channel.marketing_opt_in_state === 1">
                          <img src="@/resources/images/marketing-optin-subscribed.svg" alt="no_status" class=""/>
                          Subscribed
                        </div>
                        <div class="customerInfo optin-status-tag optin-unsubscribed" v-if="channel.marketing_opt_in_state === -1">
                          <img src="@/resources/images/marketing-optin-unsubscribed.svg" alt="no_status" class=""/>
                          Unsubscribed
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                </template>

                <div class="edit-customer-list">
                  <div class="flex-start paddingBottom flexText">
                    <p class="sub-title ion-no-margin">First Name</p>
                    <HelpTooltip>
                      Max: 60 characters
                    </HelpTooltip>
                  </div>
                  <VTextField v-model="firstName" type="text" :maxlength="60" class="vivid-input flexText" aria-label="first name" placeholder="Enter first name" appearance="ghost"></VTextField>
                </div>
                <div class="edit-customer-list">  
                  <div class="flex-start paddingBottom flexText">
                    <p class="sub-title ion-no-margin">Last Name</p>
                    <HelpTooltip>
                      Max: 60 characters
                    </HelpTooltip>
                  </div>
                  <VTextField v-model="lastName" type="text" :maxlength="60" class="vivid-input flexText" aria-label="last name" placeholder="Enter last name" appearance="ghost"></VTextField>
                </div>
                <div class="edit-customer-list">
                  <div class="flex-start paddingBottom flexText">
                    <p class="sub-title ion-no-margin">Email</p>
                    <HelpTooltip>
                      Max: 255 characters
                    </HelpTooltip>
                  </div>
                  <div class="flexText">
                    <VTextField v-model="newEmail" type="text" :maxlength="255" class="vivid-input" :class="{ 'input-error-border': emailLengthError }" aria-label="email" placeholder="Enter email" appearance="ghost" @input="handleEmailInput"></VTextField>
                    <p v-if="emailLengthError" class="inline-error-msg">Email must not exceed 255 characters.</p>
                  </div>
                </div>
      
                <div class="edit-customer-list">
                  <p class="sub-title ion-no-margin paddingBottom flexText">Gender</p>
                  <VSelect v-model="newGender" aria-label="Gender" placeholder="Select Gender" appearance="ghost" class="vivid-input flex100P">
                    <VOption value="male" text="Male"></VOption>
                    <VOption value="female" text="Female"></VOption>
                    <VOption value="others" text="Others"></VOption>
                  </VSelect>
                </div>

                <div class="edit-customer-list dobInput">
                  <p class="sub-title ion-no-margin paddingBottom flexText">Date of birth</p>
                  <VTextField class="vivid-input flex100P flexText" aria-label="start-date" readonly :modelValue="formattedDOB" placeholder="Select DOB" appearance="ghost" @click="showDatePicker = !showDatePicker"></VTextField>
                  <VIcon name="calendar-line" :size="-5" class="dob_icon cursorPointer" @click="showDatePicker = !showDatePicker"></VIcon>
                  <div v-if="showDatePicker" class="date-picker-dropdown">
                    <VDatePicker :value="newDOB" :max="moment(new Date()).format('YYYY-MM-DD')" @input="(e) => { newDOB = e.target?.value || e.detail?.value; showDatePicker = false; }"></VDatePicker>
                  </div>
                </div>

                <div class="edit-customer-list">
                  <div class="flex-start paddingBottom flexText">
                    <p class="sub-title ion-no-margin">Marketing Opt-in Status</p>
                    <HelpTooltip>
                      Marketing Opt-in Status for marketing communications:
                      <ul>
                        <li>Subscribed: Customer has opted in to receive marketing communications.</li>
                        <li>Unsubscribed: Customer has opted out of receiving marketing communications.</li>
                        <li>No status: Customer's opt-in/opt-out status is not recorded.</li>
                      </ul>
                    </HelpTooltip>
                  </div>
                  <VSelect v-model="newMarketingOptinStatus" aria-label="Marketing opt-in" placeholder="Select Status" appearance="ghost" class="vivid-input flex100P">
                    <VOption value="1" text="Subscribed"></VOption>
                    <VOption value="-1" text="Unsubscribed"></VOption>
                    <VOption value="0" text="No status"></VOption>
                  </VSelect>
                </div>

                <div v-if="crm" class="edit-customer-list">
                  <span class="sub-title flex100P">Mobile Number</span>
                  <span class="customer-details flex100P ion-text-end sub-title">
                    {{ displayMobileNumber }}
                  </span>
                </div>
                <div v-if="activeCustomer.bsuid && activeCustomer.bsuid.trim()" class="edit-customer-list flex-start">
                  <div class="flex-start ion-align-items-center flex100P">
                    <span class="sub-title ion-no-margin">WhatsApp BSUID</span>
                    <HelpTooltip>
                      A BSUID (Business-Scoped User ID) is a unique identifier that WhatsApp automatically generates for every user–business pair. It looks like US.13491208655302741918 — a country code prefix followed by up to 128 alphanumeric characters. BSUIDs replace phone numbers as the primary way businesses identify WhatsApp users who enable usernames.                    </HelpTooltip>
                  </div>
                  <div class="flex-start ion-align-items-center flex100P" style="justify-content: flex-end; gap: 0px">
                    <span class="customer-details ion-text-end sub-title">
                      {{ activeCustomer.bsuid }}
                    </span>
                    <VIcon style="cursor: pointer; color: var(--ion-color-primary); padding-left: 5px" name="copy-2-line" class="icon" @click="copyToClipboard(activeCustomer.bsuid)"></VIcon>                  </div>
                </div>

                <div v-if="activeCustomer.lastReplyTimestamp != 'None' && activeCustomer.lastReplyTimestamp != null && activeCustomer.lastReplyTimestamp != ''" class="edit-customer-list flex-start" lines="none">
                  <div class="flex-start ion-align-items-center flex100P">
                    <span class="sub-title ion-no-margin">Last interaction</span>
                    <HelpTooltip>
                      Indicates the latest communication with the customer, whether inbound or outbound.
                    </HelpTooltip>
                  </div>
                  <span class="customer-details flex100P ion-text-end sub-title">{{ renderDateTime_lastReplyTimestamp(activeCustomer.lastReplyTimestamp, 'customReadable', false) }}</span>
                </div>

                <div v-if="activeCustomer.userReplyTimestamp != 'None' && activeCustomer.userReplyTimestamp != null && activeCustomer.userReplyTimestamp != '' && crm" class="edit-customer-list" lines="none">
                  <div class="flex-start ion-align-items-center flex100P">
                    <span class="sub-title ion-no-margin">Last reply</span>
                    <HelpTooltip>
                      Indicates the latest inbound message or action received from the customer.
                    </HelpTooltip>
                  </div>
                  <span class="customer-details flex100P ion-text-end sub-title">{{ renderDateTime_lastReplyTimestamp(activeCustomer.userReplyTimestamp, 'customReadable', false) }}</span>
                </div>

                <VButton class="vvd-btn-primary vvd-btn-block bttnMargin" connotation="cta" appearance="filled" :label="!spinnerLoader ? 'Save' : ''" :disabled="!isValuesChanged || spinnerLoader" @click="updateCustomerDetails">
                  <template v-if="spinnerLoader" #icon>
                    <VProgressRing class="vvd-spinner vvd-spinner-sm" connotation="cta" indeterminate />
                  </template>
                </VButton>
              </div>
            </div>
            </transition>
          </div>

          <div class="extras">
            <!-- Tags -->
            <div class="custom_mrg_bottom">
              <div class="accordion-header" @click="toggleAccordion('tags')">
                <div class="flex100P">
                  <div class="flex-start">
                    <span class="customer-info-title">Tags</span>
                    <HelpTooltip :iconStyle="responsiveHelpTooltipIconStyle">
                      <ul>
                        <!-- <li>Max 60 tags per account</li> -->
                        <li>Max 120 characters</li>
                        <li>Alphanumeric characters only</li>
                        <li>Special characters allowed: Hyphen (-), underscore (_)</li>
                        <li> Space, tabs, or New Line is not supported</li>
                      </ul>
                    </HelpTooltip>
                  </div>
                </div>
                <VIcon :name="openAccordions.tags ? 'chevron-up-line' : 'chevron-down-line'" :size="-5" />
              </div>
              <transition name="accordion-slide">
                <div v-if="openAccordions.tags" class="cust-border-top accordion-container">
                  <div v-if="tagsLoader" class="spinner spinnerContainer">
                    <VProgressRing class="vvd-spinner" connotation="cta" indeterminate />
                  </div>
                  <div v-else class="sectionPadding">
                    <div v-if="currentCustomer.tags.length > 0" class="tagChipsList">
                      <span v-for="thisTag in currentCustomer.tags" :key="thisTag.id" class="tagChips">
                        <span class="tag-label">{{ thisTag.tag }}</span>
                        <VIcon name="close-solid" @click="deleteTag(thisTag.id)" style="padding-left: 10px; font-size: 10px; cursor: pointer"></VIcon>
                      </span>
                    </div>

                    <div class="tagContainer">
                      <CustomTagList v-model="newTag" :can-add-new="true" @tag-selected="handleTagPicked" />
                    </div>
                    <div v-if="!currentCustomer.tagsLoading && currentCustomer.moreTags && currentCustomer.tagsCursor">
                      <div @click="fetchTags(true)" class="loadMore" style="margin: 20px 0 0px 0px;">Load More</div>
                    </div>
                    <div v-else-if="currentCustomer.tagsLoading">
                      <div class="loadMore" style="margin: 20px 0 0px 0px;">Loading...</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div> 

            <!-- Custom Data -->
            <div class="custom_mrg_bottom">
              <div class="accordion-header" @click="toggleAccordion('customData')">
                <div class="flex100P">
                  <div class="flex-start">
                    <span class="customer-info-title">Custom Data</span>
                    <!-- <HelpTooltip :iconStyle="responsiveHelpTooltipIconStyle">
                      <ul>
                        <li>Max 240 custom data per account</li>
                      </ul>
                    </HelpTooltip> -->
                  </div>
                </div>
                <VIcon :name="openAccordions.customData ? 'chevron-up-line' : 'chevron-down-line'" :size="-5" />
              </div>
              <transition name="accordion-slide">
              <div v-if="openAccordions.customData" class="cust-border-top accordion-container vpb-5">
                <div v-if="saveFieldLoader" class="spinner spinnerContainer">
                  <VProgressRing class="vvd-spinner" connotation="cta" indeterminate />
                </div>
                <div v-else>
                <table>
                  <thead>
                    <tr>
                      <th class="custom-table-header">
                        <div class="flex-start">
                          <span class="sub-title">Field name</span>
                          <HelpTooltip>
                            <ul>
                              <li>Max 60 characters</li>
                              <li>Alphanumeric/Non-Latin characters only </li>
                              <li>Special characters allowed: Hyphen (-), underscore (_), period (.) </li>
                              <li>Space, tabs, or Newline is not supported </li>
                            </ul>
                          </HelpTooltip>
                      </div>
                      </th>
                      <th class="custom-table-header">
                          <div class="flex-start">
                            <span class="sub-title">Field value</span>
                            <HelpTooltip>
                              <ul>
                                <li>Max 240 characters</li>
                                <li>Printable character are allowed </li>
                                <li>Space, tabs, or newline is supported</li>
                              </ul>
                            </HelpTooltip>
                          </div>
                      </th>
                      <th class="custom-table-header align-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="singleCustomFieldArea actual" v-for="thisField in currentCustomer.custom_fields" :key="thisField.id">
                      <td>
                        <textarea class="keyText custom-scroll native-textarea" aria-label="field name" placeholder="Field name" readonly v-model="thisField.field" maxlength="60"></textarea>
                      </td>
                      <td>
                        <textarea class="valueText editField custom-scroll native-textarea" aria-label="field value" placeholder="Data value" v-model="thisField.value" :readonly="(saveFieldLoader || thisField.field == 'sentiment') ? true : false" @change="saveOrUpdateField(thisField)" maxlength="240"></textarea>
                      </td>
                      <td class="align-right">
                        <VIcon v-if="thisField.field !== 'sentiment'" name="delete-line" connotation="alert" class="trashIcon cursorPointer" @click="deleteFieldID = thisField.id"></VIcon>
                      </td>
                    </tr>
                    <tr class="singleCustomFieldArea" id="singleCustomFieldArea-new">
                      <td>
                        <VTextField type="text" :maxlength="60" class="vivid-input keyText" aria-label="field name" placeholder="Field Name" v-model="newField.field" :disabled="saveFieldLoader" appearance="ghost"></VTextField>
                      </td>
                      <td>
                        <VTextField type="text" :maxlength="240" class="vivid-input valueText" aria-label="field value" placeholder="Field Value" v-model="newField.value" :disabled="saveFieldLoader" appearance="ghost"></VTextField>
                      </td>
                      <td class="align-right">
                        <VButton @click="saveOrUpdateField(newField)" class="vvd-btn-primary" connotation="cta" appearance="filled" label="Add" :disabled="newField.field == '' || newField.value == '' || saveFieldLoader"></VButton>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="!currentCustomer.fieldsLoading && currentCustomer.moreFields && currentCustomer.fieldsCursor" class="loadMore">
                  <div @click="fetchCustomFields(true)">Load More</div>
                </div>
                <div v-else-if="currentCustomer.fieldsLoading" class="loadMore">
                  Loading...
                </div>
                </div>
              </div>
              </transition>
            </div> 

            <!-- Past Interactions -->
            <div class="custom_mrg_bottom">
              <div class="accordion-header" @click="toggleAccordion('pastInteractions')">
                <span class="customer-info-title">Past Interactions</span>
                <VIcon :name="openAccordions.pastInteractions ? 'chevron-up-line' : 'chevron-down-line'" :size="-5" />
              </div>
              <transition name="accordion-slide">
              <div v-if="openAccordions.pastInteractions" class="cust-border-top accordion-container">
                <div v-if="!loadedAgents" class="spinner spinnerContainer"> 
                  <VProgressRing class="vvd-spinner" connotation="cta" indeterminate />
                </div>
                <div v-else>
                  <div v-if="pastAgents && pastAgents.length">
                    <div v-for="thisAgent in pastAgents" :key="thisAgent.id">
                      <div class="borderContainer">
                        <div class="flex-start">
                          <img v-if="thisAgent.picture != null && thisAgent.picture != ''" :src="thisAgent.picture" alt="agent" />
                          <VAvatar connotation="accent" appearance="subtle">
                            <template #icon>
                              <VIcon name="user-line" label="User's avatar" />
                            </template>
                          </VAvatar>
                        </div>
                        <div>
                          <h2 class="vtext-body vfont-lg">{{ thisAgent.name }}</h2>
                          <p class="vtext-subtitle" v-if="thisAgent.email">{{ thisAgent.email }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="text-center sectionPadding">
                      <img src="@/resources/images/empty_purchases.svg" alt="no_past_agents" class="filterImage" />
                      <h5 class="emptyImageMargin">No past agents found who had a conversation with this customer</h5>
                    </div>
                  </div>
                </div>
              </div>
              </transition>
            </div>
          </div>
        </div>          
      </div>
      <div v-show="active_customerDetailTab === 'actions'" class="actionsContainer">
        <div v-if="calculate24Plus1RuleForCustomer(activeCustomer.userReplyTimestamp) >= 24 && activeCustomer.channel === 'whatsapp'" class="text-center errorContainer">
          <div>
            <h1 class="bigEmojiAsAnImage">&#128532;</h1>
            <h4 class="errorTitle">Sorry!</h4>
            <p class="errorDescription">You cannot initiate an action for a customer who's last message was received more than 24 hours ago</p>
          </div>
        </div>
        <div v-else>
          <div class="action-container" v-if="customerActiveView == 'actionsListView'">
            <div v-if="activeCustomer.channel !== 'sms'">
              <h3 class="title marginBottom ion-no-margin">Bot Handover</h3>
              <div class="action-items cursorPointer" @click="() => { customerActiveView = 'botFlowView'; selectedItem = { id: undefined } }">
                <img v-if="isDarkMode" src="@/resources/images/start_bot_flow-dark.svg" alt="dark" class="actionIcons" />
                <img v-else src="@/resources/images/start_bot_flow.svg" alt="bot_flow" class="actionIcons" />
                <p class="title ion-no-margin"> Start bot flow </p>
              </div>
            </div>
          </div>
        </div>
        <div class="botFlowView" v-if="customerActiveView == 'botFlowView'">
          <div class="searchBarItem">
            <VIcon @click="() => { customerActiveView = 'actionsListView' }" name="arrow-left-line" :size="-4" class="commonIcon"></VIcon>
            <p class="title ion-no-margin"> Share bot flow</p>
          </div> 
          <div class="sectionPadding">
            <BotsDropdown ref="botsDropdown" v-model="selectedItem.id" @change="(bot) => selectedItem = bot" searchPlaceholder="Search bots..." label="Select bot" :apiUrl="`bot-builder/v1/bots/?sales_channel=${activeCustomer.platform}&is_active=true`" :searchable="true" :serverSearch="false" :alwaysRefetch="true" > </BotsDropdown>
            <div v-if="selectedItem?.id" class="bttnPadding">
              <VButton @click="shareBotFlow()" class="vvd-btn-primary vvd-btn-block" connotation="cta" appearance="filled" label="Share"></VButton>
            </div>  
        </div>
        </div>
      </div>
    </div>
    </div>
    <!-- Bot flow alert -->
    <VDialog
      :open="confirmSharingBotFlow"
      headline="Are you sure?"
      modal
      @close="() => { botFlowToShare = null; confirmSharingBotFlow = false; }"
    >
      <template #body>
        <p class="vtext-body"><b>{{ activeCustomer.name }}</b> will be able to interact with this bot.</p>
        <p class="vtext-body">This will end any automated conversation that they are interacting with</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => { botFlowToShare = null; confirmSharingBotFlow = false; }"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="startABotBuilderFlowForThisTrigger"></VButton>
      </template>
    </VDialog>

    <VDialog
      :open="confirmResolveBttn"
      headline="Are you sure?"
      modal
      @close="() => confirmResolveBttn = false"
    >
      <template #body>
        <p class="vtext-body">This will mark Conversation as done!</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => confirmResolveBttn = false"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="resolvedBttn"></VButton>
      </template>
    </VDialog>

    <VDialog
      v-if="!!deleteFieldID"
      :open="!!deleteFieldID"
      headline="Are you sure?"
      modal
      @close="() => deleteFieldID = undefined"
    >
      <template #body>
        <p class="vtext-body">You want to delete this custom field?</p>
      </template>
      <template #action-items>
        <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => deleteFieldID = undefined"></VButton>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="deleteField"></VButton>
      </template>
    </VDialog>
</template>

<script>
import { allCountryCurrencyData } from '@/resources/js/all-countries-currencies-list';
import { getLocaleName } from '@/resources/js/all-locale-data';
import { getFormattedTimezone } from '@/resources/js/all-timezones-data';
import { getMobileNetworkName_fromMccMncList } from '@/resources/js/mcc-mnc-country-network-list';
import '/src/resources/css/page-inbox.css';
import { calculate24Plus1RuleForCustomer } from '@/helpers/chat.helpers';
import { renderDateTime_lastReplyTimestamp } from '@/helpers/date.helpers';
import apiInterceptor from '@/shared/apiInterceptor';
import CustomerConnectedChannel from '/src/components/customerConnectedChannel.vue'
import { channels } from "@/resources/js/bot-builder.js";
import moment from 'moment';
import HelpTooltip from "/src/components/HelpTooltip.vue";
import conversationDeletedIcon from '@/resources/images/conversation_deleted.svg'; // conversationDeletedIcon is used in the template as a prop for HelpTooltip
import BotsDropdown from '@/components/BotsDropdown.vue';
import CustomTagList from '@/components/CustomTagList.vue';
import { validateCustomField, validateTag } from '@/helpers/customFields.helpers';
import { checkIfThereIsNoLogoThenShowTransparentImage, renderCustomerImage_style_background } from '@/helpers/image.helpers';
import { uniqueObjectiveArray } from '@/helpers/global.helpers';
import { validateEmail } from '@/helpers/validation.helpers';
import { useUIStore } from '@/stores/ui';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { useClipboard } from '@/composables/useClipboard';
import { environment } from '@/shared/env.js';
import { queryClient } from '@/shared/queryClient';
import { customDataFieldsQueryOptions } from '@/composables/useCustomDataFields';
import { customerTagsQueryOptions } from '@/composables/useCustomerTags';

let intervalId = null;

export default {
  components: { CustomerConnectedChannel, HelpTooltip, BotsDropdown, CustomTagList },
  mixins: [],
  setup() {
    const { getChannelFromPageActive, whatsAppSocialData, smsSocialData, googlercsSocialData } = useSocialChannels();
    const { copyToClipboard } = useClipboard();
    return { getChannelFromPageActive, whatsAppSocialData, smsSocialData, googlercsSocialData, copyToClipboard };
  },
  emits: ['reassign', 'user_info_updated', 'sendReminder', 'resolved_chat'],
  props: {
    conversationid: {
      type: String,
      required: true
    },
    activeCustomer: {
      type: Object,
      default: null,
      required: true
    },
    page_conversation_id: {
      type: String
    },
    pageid: {
      type: String
    },
    platform: {
      type: String
    },
    agentReAssignmentAllowed: {
      type: Boolean,
      default: false
    },
    crm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customerActiveView: 'actionsListView',
      active_customerDetailTab: 'userDetails',
      newField: {
        field: undefined,
        value: undefined
      },
      addNewTagMode: false,
      newTag: undefined,
      star: 'star-line',
      conversationDeletedIcon,
      maleOutline: 'gender-male-line',
      femaleOutline: 'gender-female-line',
      newName: undefined,
      firstName: undefined,
      lastName: undefined,
      newEmail: undefined,
      newMobile: undefined,
      newCustomerImage: undefined,
      // Locally-tracked image after a successful upload, so we can show it
      // immediately without mutating the activeCustomer prop.
      uploadedImageOverride: null,
      newGender: undefined,
      newMarketingOptinStatus: undefined,
      newDOB: undefined,
      newCountryCode: undefined,
      followupTag: undefined,
      loadedAgents: false,
      pastAgents: [],
      confirmSharingBotFlow: false,
      botFlowToShare: null,
      selectedItem: { id: undefined },
      fbImage: `https://graph.facebook.com/${this.activeCustomer.channel_id}/picture?type=normal `,
      commonLoader: true,
      isBotSelected: false,
      shareImageSelected: false,
      spinnerLoader: false,
      customerOrigin: '',
      allfetchImagesResponse: {},
      selectedItems: {
        image: false,
        price: false,
        description: false
      },
      selectedImages: [],
      selectedNamePrice: [],
      selectedDescriptions: [],
      checkboxValues: [],
      nexmo: {
        app: { },
        call: {
          id: undefined,
          status: undefined //in-call, ringing, ended
        },
        customer: {
          countrycode: undefined,
          mobile: undefined
        }
      },
      toRecord: false,
      nexmoCall: { },
      callingScreen: false,
      enterNumberScreen: true,
      startTime: undefined,
      now: undefined,
      currentCustomer: {
        tags: [],
        moreTags: false,
        tagsCursor: undefined,
        custom_fields: [],
        moreFields: false,
        fieldsCursor: undefined
      },
      confirmResolveBttn: false,
      showDatePicker: false,
      activeCustomerUpdated: { ...this.activeCustomer },
      loadedLogs: false,
      callLogs: [],
      callLogsCursor: null,
      channels,
      nameError: "",
      emailLengthError: false,
      namePattern: /^[\p{L}\p{M}\s'-]{1,60}$/u, // Regex: Allows 1-60 characters, including letters from any language, diacritical marks, spaces, apostrophes, and hyphens.
      deleteFieldID: undefined,
      saveFieldLoader: false,
      customer_image_updated: false,
      tagsLoader: false,
      isResolving: false,
      openAccordions: {
        customerDetails: true,
        tags: false,
        customData: false,
        pastInteractions: false
      }
    }
  },
  async mounted() {
    this.initCustomer();
  },
  beforeUnmount() {
    this.changeNow('stop');
  },
  watch: {
    page_conversation_id: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.initCustomer();
        }
      },
    }
  },
  computed: {
    isDarkMode() { return useUIStore().isDarkMode; },
    totalElapsedTime() {
      if(this.nexmo.call.id && this.startTime && this.now) {
        const formatNumber = (number) => {
          return number.toString().padStart(2, '0');
        }
        const totalSeconds = this.now.diff(this.startTime, 'seconds');
        const hours = formatNumber(totalSeconds > 3600 ? Math.floor(totalSeconds / 3600) : 0);
        const minutes = formatNumber(totalSeconds > 60 ? Math.floor((totalSeconds % 3600) / 60) : 0);
        const seconds = formatNumber(totalSeconds > 0 ? (totalSeconds % 60) : 0);
        return `${hours}:${minutes}:${seconds}`;
      }
      return '00:00:00';      
    },
    isMobileEditable() {
      return this.activeCustomer.channel === 'line'
    },
    // Overlay a just-uploaded image on top of the activeCustomer prop so the
    // avatar updates immediately, without mutating the prop directly.
    customerForDisplay() {
      if (!this.activeCustomer) return this.activeCustomer;
      if (this.uploadedImageOverride == null) return this.activeCustomer;
      return { ...this.activeCustomer, image: this.uploadedImageOverride };
    },
     isValuesChanged() {
      const norm = (val) => (val === 'unrecorded' || val === 'None' || val == null) ? '' : val;
      return norm(this.firstName) !== norm(this.activeCustomer.first_name) ||
      norm(this.lastName) !== norm(this.activeCustomer.last_name) ||
      norm(this.newEmail) !== norm(this.activeCustomer.email) ||
      norm(this.newGender) !== norm(this.activeCustomer.gender) || 
      norm(this.newDOB) !== norm(this.activeCustomer.dob) || 
      norm(this.newMobile) !== norm(this.activeCustomer.mobile) || 
      this.newCustomerImage !== this.activeCustomer.image ||
      String(this.newMarketingOptinStatus) !== String(this.activeCustomer.marketing_opt_in_state ?? '0')
    },
    formattedDOB() {
      return this.newDOB
        ? moment(this.newDOB).format('DD-MM-YYYY')
        : '';
    },
    displayMobileNumber() {
      const mobile = this.activeCustomer.mobile;
      if (mobile && mobile !== 'unrecorded' && mobile !== 'None') {
        return `${this.activeCustomer.mobilecountrycode} ${mobile}`;
      }
      return 'Not captured';
    },
    responsiveHelpTooltipIconStyle() {
      return {
        'padding-top': window.innerWidth <= 768 ? '2px' : '3px'
      };
    },
    sortedPlatforms() {
      const ORDER = ['whatsapp', 'googlercs', 'sms']
      return [...(this.activeCustomer.all_platforms ?? [])].sort(
        (a, b) => {
          const ai = ORDER.indexOf(a.platform)
          const bi = ORDER.indexOf(b.platform)
          return (ai === -1 ? ORDER.length : ai) - (bi === -1 ? ORDER.length : bi)
        }
      )
    }
  },
  methods: {
    moment,
    getLocaleName, getFormattedTimezone, getMobileNetworkName_fromMccMncList, calculate24Plus1RuleForCustomer,
    renderDateTime_lastReplyTimestamp,
    checkIfThereIsNoLogoThenShowTransparentImage,
    renderCustomerImage_style_background,
    getFormattedReferredOriginName(name){
      if(typeof name != 'undefined' && name != null){
        var nameLowerCase = name.toLowerCase();

        var channel = "";
        if(nameLowerCase == 'sms'){
          channel = "SMS";
        }
        else if(nameLowerCase == 'whatsapp'){
          channel = "WhatsApp";
        }
        else if(nameLowerCase == 'blog' || nameLowerCase == 'incontext'){
          channel = "Blog chatbot";
        }
        else if(nameLowerCase == 'chatbox' || nameLowerCase == 'widget'){
          channel = "Chatbox";
        }
        else{
          channel = name;
        }

        return channel;
      }
    },
    changeNow(type) {
      switch(type) {
        case 'start': 
          intervalId = setInterval(() => {
            this.now = moment(Date.now());
          }, 1000);
        break;
        case 'stop': 
          intervalId ? clearInterval(intervalId) : 0;
        break;
      }
    },
    getDeviceTypeFromUseragent(userAgentText) {
			if (typeof userAgentText != 'undefined') {
				var info = window.platform.parse(userAgentText);
		
				var result = "Unknown";
		
				if (typeof info != 'undefined') {
					if (typeof info.description != 'undefined') {
						result = info.description;
					}
				}
		
				return result;
			}
		},
    getFullCountryNameFrom2CharName(input) {
      if(input) return allCountryCurrencyData.find(e => e.country_short_code.toLowerCase() === input.toLowerCase())?.country_name;
		},
    toggleAccordion(section) {
      const isOpen = this.openAccordions[section];
      // Close all sections first
      Object.keys(this.openAccordions).forEach(key => {
        this.openAccordions[key] = false;
      });
      // Toggle the clicked section (if it was closed, open it)
      if (!isOpen) {
        this.openAccordions[section] = true;
      }
    },
    openActionsTab() {
      if (this.active_customerDetailTab === 'actions') return;
      this.active_customerDetailTab = 'actions';
      this.$refs.botsDropdown?.refresh();
    },
    initCustomer() {
      this.customerActiveView = 'actionsListView',
      this.active_customerDetailTab = 'userDetails',
      // Set default open accordion based on mode
      this.openAccordions = {
        customerDetails: !this.crm,
        tags: this.crm,
        customData: false,
        pastInteractions: false
      };
      this.newName = this.activeCustomer.name;
      if(this.newName === 'unrecorded') this.newName = '';
      this.firstName = this.activeCustomer.first_name;
      if(this.firstName === 'unrecorded') this.firstName = '';
      this.lastName = this.activeCustomer.last_name;
      if(this.lastName === 'unrecorded') this.lastName = '';
      this.newEmail = this.activeCustomer.email;
      if(this.newEmail === 'unrecorded') this.newEmail = '';
      this.newMobile = this.activeCustomer.mobile;
      this.newCustomerImage = this.activeCustomer.image;
      // Clear any prior upload overlay; the freshly loaded customer carries the
      // up-to-date image (including one just saved) from the backend.
      this.uploadedImageOverride = null;
      this.newGender = this.activeCustomer.gender;
      this.newMarketingOptinStatus = (this.activeCustomer.marketing_opt_in_state !== null && this.activeCustomer.marketing_opt_in_state !== undefined) ? this.activeCustomer.marketing_opt_in_state.toString() : '0';
      this.newDOB = this.activeCustomer.dob;
      this.newCountryCode = this.activeCustomer.mobilecountrycode;
      this.followupTag = this.activeCustomer.followup;
      this.loadPastAgents();
      this.fetchTagsandCustomFields();
      this.customerOrigin = this.getFormattedReferredOriginName(this.getChannelFromPageActive(this.activeCustomer.channel));
    },
    async loadPastAgents() {
      try {
        this.loadedAgents = false;
        let conversationid = this.conversationid;
        let agentsResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "crm/v1/customers/" + conversationid + '/past-agents' );
        this.pastAgents = uniqueObjectiveArray(agentsResponse.assigned,'id');
        this.loadedAgents = true;
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally{
        this.loadedAgents = true;
      }
    },
    async fetchTags(loadMore){
			try {
        // Scope the loader to the Tags section only, so refetching tags after a
        // mutation doesn't re-mount the whole customer details section [APICC-3478].
        this.tagsLoader = true;
        let reqBody = {};
        if (loadMore && this.currentCustomer.tagsCursor && this.currentCustomer.moreTags) {
          reqBody["tag_cursor"] = this.currentCustomer.tagsCursor;
          this.currentCustomer.tagsLoading = true;
        }
        const params = { ...reqBody };
        const tagsResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.conversationid + "/tags", { params } );
        if (tagsResponse && Array.isArray(tagsResponse.data)) {
          if (this.currentCustomer.tagsLoading) {
            this.currentCustomer.tags = this.currentCustomer.tags.concat(tagsResponse.data);
            this.currentCustomer.tagsLoading = false;
          } else {
            this.currentCustomer.tags = tagsResponse.data;
          }

          this.currentCustomer.moreTags = tagsResponse.more ?? false;
          this.currentCustomer.tagsCursor = tagsResponse.cursor ?? null;
        } else {
          console.warn('Invalid tagsResponse:', tagsResponse);
        }
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger",
        });
      } finally {
        this.tagsLoader = false;
      }
    },
    async fetchCustomFields(loadMore){
			try {
        // Scope the loader to the Custom Data section only, so refetching fields
        // after a mutation doesn't re-mount the whole details section [APICC-3478].
        this.saveFieldLoader = true;
        let reqBody = {};
        if (loadMore && this.currentCustomer.fieldsCursor && this.currentCustomer.moreFields) {
          reqBody["custom_field_cursor"] = this.currentCustomer.fieldsCursor;
          this.currentCustomer.fieldsLoading = true;
        }
        const params = { ...reqBody };
        const tagsandCustomFieldResponse = await apiInterceptor.get( environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.conversationid + "/custom-fields", { params } );

        if ( this.currentCustomer.fieldsLoading) {
          this.currentCustomer.custom_fields = this.currentCustomer.custom_fields.concat(tagsandCustomFieldResponse.data);
          this.currentCustomer.fieldsLoading = false;
        } else {
          this.currentCustomer.custom_fields = tagsandCustomFieldResponse.data;
        }
        this.currentCustomer.moreFields = tagsandCustomFieldResponse.more;
        this.currentCustomer.fieldsCursor = tagsandCustomFieldResponse.cursor;
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger",
        });
      } finally {
        this.saveFieldLoader = false;
      }
    },
    async fetchTagsandCustomFields(){
			try {
        await this.fetchTags();
        await this.fetchCustomFields();
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger",
        });
      }
    },
    async followUpBttn(){
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Please wait...' });
        let conversationid = this.conversationid;
        await apiInterceptor.post( environment("VUE_APP_API_URL") + "livechat/v1/core/chats/" + conversationid + '/follow_up' );
        useUIStore().updateToast({
          open: true,
          message: this.followupTag ? "Customer removed from follow-up list!" : "Customer added to follow-up list!",
          type: "success",
        });
        this.followupTag = !this.followupTag;
        this.activeCustomer.followup = !this.activeCustomer.followup;
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async resolvedBttn(){
      try {
        if(this.activeCustomer.assigned_to != null || (this.activeCustomer.active == false) ) {
          this.isResolving = true;
          let reqBody = {
            platform: this.platform,
          };
          await apiInterceptor.post( environment("VUE_APP_API_URL") + "livechat/v1/core/chats/" + this.conversationid + '/mark-resolved', reqBody );
          this.$nextTick(() => {
            this.$emit('resolved_chat');
          })
          useUIStore().updateToast({ open: true, message: "Conversation marked as done!", type: "success" });
          this.confirmResolveBttn = false;
        } else {
          useUIStore().updateToast({
            open: true,
            message: "Not Allowed",
            type: "danger",
          });
        }
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        });
      } finally {
        this.isResolving = false;
        this.confirmResolveBttn = false;
      }
    },
    async startABotBuilderFlowForThisTrigger() {
      useUIStore().updateLoading({ isLoading: true, message: 'Please wait...' });
      if (this.botFlowToShare.triggers?.length) {
        let reqBody = {
          conversationid: this.conversationid,
          page_conversation_id: this.page_conversation_id,
          pageid: this.pageid,
          platform: this.platform,
          hashtag: this.botFlowToShare.triggers[0],
        };
        try {
          await apiInterceptor.post(environment("VUE_APP_API_URL") + "social/v1/bot-takeover", reqBody );
          this.customerActiveView = 'actionsListView';
          useUIStore().updateToast({
            open: true,
            message: "Flow has been sent successfully to the customer.",
            type: "success",
          });
        } catch (error) {
          useUIStore().updateToast({
            open: true,
            message: error.message || "Something went wrong",
            type: "danger",
          });
        } finally {
          this.confirmSharingBotFlow = false;
          this.botFlowToShare = null;
          useUIStore().updateLoading({ isLoading: false });
          this.selectedItem = { id: undefined };
        }
      } else {
        useUIStore().updateToast({
          open: true,
          message: "The selected bot flow cannot be sent",
          type: "danger",
        });
      }
    },
    shareBotFlow(){
      this.botFlowToShare = this.selectedItem; 
      this.confirmSharingBotFlow = true;
    },
    async saveOrUpdateField(field) {
      try {
        const isNewField = !field.id;
        validateCustomField(field.field, field.value, true);
        let customFieldResponse;
        this.saveFieldLoader = true;
        if (isNewField) {
          customFieldResponse = await apiInterceptor.post(environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.conversationid + "/custom-fields", { custom_field: field.field, custom_value: field.value });
        } else {
          customFieldResponse = await apiInterceptor.patch(environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.conversationid + "/custom-fields/" + field.id, { custom_value: field.value });
        }
        await this.fetchCustomFields();
        let message = "Custom fields saved successfully!";
        if (customFieldResponse.message && typeof customFieldResponse.message === "string" && customFieldResponse.message.trim() !== "") {
          message = customFieldResponse.message;
        } else if (typeof customFieldResponse.message === "object") {
          message = "Custom fields saved successfully!";
        } else if (!customFieldResponse.message) {
          message = "Custom fields saved successfully!";
        } else {
          message = "Something went wrong";
        }
        await queryClient.invalidateQueries({ queryKey: customDataFieldsQueryOptions.queryKey });
        if (isNewField) {
          this.newField = { field: undefined, value: undefined };
        }
        useUIStore().updateToast({ open: true, message: message, type: "success", duration: 3500 });
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message || 'Something went wrong',
          type: "danger"
        });
      } finally {
        this.saveFieldLoader = false;
        this.newField = { field: undefined, value: undefined };
      }
    },
    handleTagPicked(payload) {
      const tag = payload?.value;
      if (!tag) return;
      this.saveNewTag(tag);
    },
    async saveNewTag(tag = this.newTag) {
      try {
        const validationError = validateTag(tag, this.currentCustomer.tags);
        if (validationError) {
          useUIStore().updateToast({ open: true, message: validationError, type: "danger" });
          return;
        }
        this.tagsLoader = true;
        await apiInterceptor.post(environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.conversationid + '/tags', { tag });
        await this.fetchTags();
        // Refresh the account-wide tag list so the new tag shows up in the
        await queryClient.invalidateQueries({ queryKey: customerTagsQueryOptions.queryKey });
        useUIStore().updateToast({
          open: true,
          message: "New tag added successfully!",
          type: "success"
        });
      } catch (error) {
        console.error("Exception", error);
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        this.tagsLoader = false;
        this.newTag = undefined;
        this.addNewTagMode = false;
      }
    },
    async deleteField() {
      try {
        if(!this.deleteFieldID) {
          useUIStore().updateToast({
            open: true,
            message: "Something went wrong, please refresh!",
            type: "danger"
          })
          return;
        }
        this.saveFieldLoader = true;
        await apiInterceptor.delete(environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.conversationid + '/custom-fields/' + this.deleteFieldID);
        await this.fetchCustomFields(); 
        useUIStore().updateToast({
          open: true,
          message: "Custom field data deleted successfully",
          type: "success"
        })
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        this.deleteFieldID = undefined;
        this.saveFieldLoader = false;
      }
    },
    async deleteTag(id) {
      try {
        if(!id) {
          useUIStore().updateToast({
            open: true,
            message: "Something went wrong, please refresh!",
            type: "danger"
          })
          return;
        }
        this.tagsLoader = true;
        await apiInterceptor.delete(environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.conversationid + '/tags/' + id);
        await this.fetchTags();
        useUIStore().updateToast({
          open: true,
          message: "Tag deleted successfully.",
          type: "success"
        });
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        this.tagsLoader = false;
      }
    },
    validateNames(value) {
      var name;
      if(value == 'First Name'){
        name = this.firstName;
      } else if(value == 'Last Name') {
        name = this.lastName;
      }
      
      if (name.length > 60) {
        this.nameError =  value + " must not exceed 60 characters";
        return false;
      }
      if (!this.namePattern.test(value)) {
        this.nameError = value + " contains invalid characters";
        return false;
      }
      
      this.nameError = "";
      return true;
    },
    handleEmailInput(event) {
      const value = event.target?.value || event.detail?.value || '';
      if (value.length >= 255) {
        this.emailLengthError = true;
        this.newEmail = value.substring(0, 255);
      } else {
        this.emailLengthError = false;
      }
    },
    async updateCustomerDetails() {
      try {
        if (this.newEmail && this.newEmail.length >= 255) {
          this.emailLengthError = true;
          return;
        }
        let reqBody = {};

        if (this.firstName !== this.activeCustomer.first_name) {
          if (this.firstName && !this.validateNames('First Name')) {
            return useUIStore().updateToast({ open: true, message: this.nameError, type: "danger" });
          }
          reqBody['first_name'] = this.firstName;
        }
        if (this.lastName !== this.activeCustomer.last_name) {
          if (this.lastName && !this.validateNames('Last Name')) {
            return useUIStore().updateToast({ open: true, message: this.nameError, type: "danger" });
          }
          reqBody['last_name'] = this.lastName;
        }
        if (this.newEmail !== this.activeCustomer.email) {
          if (this.newEmail && !validateEmail(this.newEmail)) {
            return useUIStore().updateToast({ open: true, message: "Please enter a valid email ID", type: "danger" });
          }
          reqBody['email'] = this.newEmail;
        }
        if (this.newMobile && this.newMobile !== this.activeCustomer.mobile) {
          if (!this.newCountryCode) {
            return useUIStore().updateToast({ open: true, message: "Please select a country code", type: "danger" });
          }
          reqBody['country_code'] = this.newCountryCode;
          
          if (this.newMobile < 0 || this.newMobile.toString().length < 8 || this.newMobile.toString().length > 13) {
            return useUIStore().updateToast({ open: true, message: "Please enter a valid mobile number", type: "danger" });
          }
          reqBody['mobile_number'] = this.newMobile;
        }

        if (this.newGender && this.newGender !== this.activeCustomer.gender) {
          reqBody['gender'] = this.newGender;
        }
        const currentOptInState = (this.activeCustomer.marketing_opt_in_state !== null && this.activeCustomer.marketing_opt_in_state !== undefined) ? String(this.activeCustomer.marketing_opt_in_state) : '0';
        if (this.newMarketingOptinStatus && String(this.newMarketingOptinStatus) !== currentOptInState) {
          reqBody['marketing_opt_in_state'] = this.newMarketingOptinStatus;
        }
        if (this.newDOB && this.newDOB !== this.activeCustomer.dob) {
          reqBody['dob'] = moment(this.newDOB).format("DD/MM/YYYY");
        }
        if (this.customer_image_updated) {
          reqBody['image'] = this.newCustomerImage;
        }
        if (Object.keys(reqBody).length > 0) {
          this.spinnerLoader = true;
          const updateUserResponse = await apiInterceptor.put( environment("VUE_APP_API_URL") + "crm/v1/customers/" + this.activeCustomer.conversationid, reqBody );
          if(!this.crm) {
            this.$emit('user_info_updated', reqBody);
          }
          this.newName = updateUserResponse.name;
          // Reflect the newly uploaded image locally (via a computed overlay) so
          // CustomerConnectedChannel updates immediately, without mutating the
          // activeCustomer prop directly.
          if (this.customer_image_updated) {
            this.uploadedImageOverride = this.newCustomerImage;
          }
          this.activeCustomer.marketing_opt_in_state = parseInt(this.newMarketingOptinStatus);
          for(var i = 0; i < this.activeCustomer.all_platforms.length; i++){
            if(this.activeCustomer.all_platforms[i].conversation_key === this.activeCustomer.conversationid){
              this.activeCustomer.all_platforms[i].marketing_opt_in_state = parseInt(this.newMarketingOptinStatus);
            }
          }
          useUIStore().updateToast({
            open: true,
            message: "User Info updated successfully.",
            type: "success"
          });
        }
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        });
      } finally {
        this.spinnerLoader = false;
        this.customer_image_updated = false;
      }
    },
    async handleCustomerImage(value) {
      this.newCustomerImage = value.image_url;
      this.customer_image_updated = true;
      await this.updateCustomerDetails();
    }
  }
}
</script>

<style scoped lang="scss">
.header.liveChat {
  position: sticky;
  top: 0;
  z-index: 100;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.custom-tabs {
  display: flex;
  background: var(--white);
  border-bottom: 2px solid var(--background-primary);
}
.custom-tab {
  flex: 1;
  text-align: center;
  padding: 14px 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--gray-04);
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
}
.custom-tab.active {
  color: var(--purple);
}
.custom-tab.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--purple);
}
.user-detail-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.customer-info{
  background: var(--background-primary);
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.customer-details-header{
  padding-top: 20px;
  background: var(--white);
  margin-bottom: 10px;
}
.customer-name {
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: var(--black);
}
.customer-options{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  margin: 20px 0px;
}
.customer-options .text {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--gray-04);
  padding-top: 10px;
}
.agent-img{
  display: flex;
  align-items: center;
  margin: 4px auto 0px auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.agent-img-inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.flexBox{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.description .title {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--gray-04);
  padding-bottom: 5px;
}
.agent-details {
  padding: 20px 10px 20px 10px;
  border-top: 1px solid var(--background-primary);
}
.interaction_container{
  padding: 20px;
  border-top: 1px solid var(--background-primary);
}
.agent-details .flexBox > .flexBox {
  min-width: 0;
  overflow: hidden;
}
.agent-details .flexBox > ion-button {
  flex-shrink: 0;
}
.agent-details .description {
  min-width: 0;
}
.agent-details .description h2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.action-container{
  background: var(--white);
  padding: 20px;
}
.marginBottom40P{
  margin-bottom: 40px;
}
.action-container .action-items {
  background: var(--background-primary);
  border-radius: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 15px; 
}
.shareProductView {
  background: var(--white);
}
.backIcon{
  color: var(--black);
  padding-right: 10px;
  cursor: pointer;
}
.searchBarItem{
  border-bottom: 1px solid var(--background-primary);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 15px;
}
.botFlowView .action-items {
  background: var(--background-primary);
  border-radius: 5px;
  margin-bottom: 10px;
  cursor: pointer;
  min-height: 60px;
}
.botSearchBar {
  margin-bottom: 20px;
  background: var(--background-primary);
  border-radius: 5px;
}


.info-message{
  width: 100%;
  padding: 15px;
  margin-top: 20vh;
}
.botFlowView .selected {
  --background: var(--purple);
  color: var(--white);
}

.botFlowView .selectedIcon{
  display: block !important;
  color: var(--white);
}
.botFlowView .iconImg{
  display: none;
}
.borderContainer{
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  border-bottom: 1px solid var(--background-primary);
}
.filterImage {
  max-width: 200px; 
  width: 100%;
  height: auto; 
  display: block;
  margin: 0 auto;
}


.info-box{
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  background: var(--purple-opac);
  border-radius: 5px;
  padding: 5px 10px 5px 10px;
}
.spinner{
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-text{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--black);
  margin-left: 15px;
}
.shareLink{
  background: var(--background-primary);
  border-radius: 5px;
  padding: 5px 5px 5px 5px;
}
.cust-margin {
  margin-top: 20px;
}
.bigEmojiAsAnImage{
  font-size: 50px;
  margin: 0px;
  line-height: 1.4;
}
.errorContainer{
  padding: 20px;
  background: var(--white);
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.errorTitle{
  color: var(--black);
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 5px;
  margin-top: 0px;
}
.errorDescription{
  color: var(--black);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  margin-bottom: 5px;
  margin-top: 0px;
}
.errorMessage {
  font-size: 18px;
  color: var(--black);
  font-weight: 400;
  list-style: 1.4;
}
.inline-error-msg {
  color: var(--ion-color-danger, #eb445a);
  font-size: 12px;
  margin: 4px 0 0 0;
  padding: 0;
}
.input-error-border {
  --border-color: var(--ion-color-danger, #eb445a);
  border-color: var(--ion-color-danger, #eb445a);
}
.spinnerContainer{
  padding: 20px;
}

.emptyFiltersImage {
  max-width: 200px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.img-responsive{
  width: 40px;
  height: 40px;
  border-radius: 5px;
}
.custPadding{
  padding-bottom: 5px;
}
.cust-border-top{
  border-top: 1px solid var(--gray-01);
}
/* Custom accordion styles */
.accordion-header {

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  cursor: pointer;
  background: var(--white);
  border-radius: 5px 5px 0 0;
}
.accordion-header:hover {
  opacity: 0.8;
}
/* Accordion slide transition */
.accordion-slide-enter-active,
.accordion-slide-leave-active {
  transition: all 0.25s ease;
  max-height: 2000px;
  opacity: 1;
  overflow: hidden;
}
.accordion-slide-enter-from,
.accordion-slide-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
.requestInfo{
  padding: 0px 12px 12px 12px;
}
.custMargin{
  margin-bottom: 20px;
}
.setItems{
  --background: var(--background-primary);
  border-radius: 5px;
  --padding-start: 0px;
}
.listAccordion{
  background: var(--background-primary);
  margin-bottom: 10px;
  border-radius: 5px;
}
.share-img-responsive{
  width: 85px;
  height: 93px;
  border-radius: 5px;
}
.borderContainerCustom{
  border-bottom: 1px solid var(--gray-01);
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.loadMore {
  width: 100%; 
  text-align: center; 
  color: var(--ion-color-primary); 
  margin: 10px 0 20px 0px;
  cursor: pointer;
}
.custom-table-header{
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--gray-04);
  text-transform: none;
  border: none !important;
}
td,th {
  padding: 12px;
  text-align: left;
  border-width: 0px 0px 0px 0px;
}
.singleCustomFieldArea td{
  padding: 5px 12px 5px 0px;
}
.singleCustomFieldArea:nth-last-child(2){
  border-bottom: none;
}
table {
  border-width: 0px;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  background: none;
}
table tr td {
  border-width: 0px;
  padding: 5px;
}
.emptyImageMargin{
  margin: 20px;
  font-size: 14px;
  color: var(--gray-04);
  font-weight: 400;
  line-height: 16px;
}
.purchaseitems{
  border-bottom: 1px solid var(--background-primary);
}
.purchaseitems:last-child{
  border-bottom: none;
}
.list-container{
  padding: 0px 20px 10px 20px;
  border-top: 1px solid var(--background-primary);
}
.whiteBtnWithIconOnLeft{
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px var(--background-primary) solid;
  border-radius: 21px;
  min-width: 40%;
  max-width: 60%;
  margin: 15px auto;
  cursor: default;
  text-decoration: none;
}
.image-container {
  flex: 0 0 auto;
}
.fbUserName{
  color: var(--purple);
  font-size: 14px;
  font-weight: 400;
}
.text-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fbImg{
  border-radius: 50%;
  display: inline-block;
  height: 40px;
  width: 40px;
  vertical-align: middle;
}
.cust-title{
  font-size: 18px;
  font-weight: 400;
  color: var(--black);
  line-height: 16px;
  max-width: 80%;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.orderSet{
  margin-left: 10px;
  padding: 5px;
  border-radius: 5px;
  background: var(--purple-opac);
}
.loadingScreen{
  display: flex;
  flex-direction: column;
  margin: 50% 0px;
}

.purchaseImg{
  border-radius: 5px;
  border: 1px solid var(--background-primary);
}
.customer-image-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.calling-screen, .mobile-screen {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.marginTop{
  margin-top: 40px;
}
.user-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.user-name {
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: var(--black);
  margin-top: 10px;
}
.call-status{
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  margin-top: 10px;
  color: var(--gray-04);
  text-align: center;
}
.bottom-section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 100px;
  margin-top: 20px;
}
.button-icon {
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.paddingLeft{
  padding-left: 10px;
}
.flexContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mobilePadding {
  padding: 10px 5px 10px 5px;
}

.tagChipsList {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.tagChips{
  margin: 0px 10px 10px 0px;
  overflow-wrap: anywhere;
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 6px 12px;
  border-radius: 20px;
  background: var(--background-primary);
  font-size: 14px;
  color: var(--black);
  cursor: default;
}
.tagChips:hover {
  background: var(--purple);
  color: var(--white);
}
.tagChips > .tag-label {
  flex: 0 1 90%;
}
.botFlowView {
  background: var(--white);
  min-height: 100dvh;
}
.log-wrapper {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  width: 100%;
}
.log {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
}
.log > .title {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  margin-bottom: 5px;
  font-size: 1rem;
}
.log > .title > .name {
  white-space: nowrap;
}
.log > .sub-title {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  margin-bottom: 5px;
  font-size: 0.9rem;
  color: var(--gray-04)
}
.tag {
  text-transform: uppercase;
  font-size: 0.8rem;
  border-radius: 3px;
  background-color: whitesmoke;
  color: var(--highlight-color-focused);
  background-color: #F4E9FF;
  padding: 3px 5px;
  margin-left: 5px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 10px;
}
.avatar > img {
  width: 100%;
}
.flex-box{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0px 10px 0px;
}
.url-text{
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icons {
  color: var(--gray-04);
  width: 25px;
  height: 25px;
}
p.overUserImageChannelIconContainer img.platformIconInLineWithText {
  width: 25px;
  height: 25px;
}

.tagContainer{
  display: flex;
  align-items: center;
  gap: 10px;
}
.actionsContainer{
  height: 100%;
  background: var(--white);
}
.productListItems{
  margin-bottom: 0px;
  height: calc(100svh - 200px);
  min-height: 150px;
  overflow: hidden;
  overflow-y: auto;
}
.productListItems.scrollable {
  overflow-y: hidden;
  margin-bottom: 0px;
  height: auto;
}
.bttnPadding{
  padding: 20px 0px;
  position: sticky;
  bottom: 0;
  left: 0;
  background: var(--white);
  width: 100%;
  z-index: 100;
}
.conversation_channel{
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.filterAssigned .img-sections {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
}
.filterAssigned .img-sections img{
  width: 25px;
  height: 25px;
}
.edit-customer-list{
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid var(--background-primary);
}
.source-container{
  padding: 0px 20px 0px 20px;
  border-top: 1px solid var(--background-primary);
}

.toggle-button {
  display: flex;
  align-items: center;
  margin: 10px 0px 0px 0px;
}
.dob_icon{
  position: absolute;
  right: 12px;
  bottom: 27px;
  z-index: 9;
}
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  width: 100%;
}
.dobInput {
  position: relative;
}
.date-picker-dropdown {
  position: absolute;
  top: 83%;
  right: 15px;
  z-index: 1000;
  background: var(--white);
  border: 1px solid var(--background-primary);
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.native-textarea {
  width: 100%;
  min-height: 36px;
  padding: 8px;
  border: none;
  border-radius: 5px;
  background: var(--background-primary);
  font-size: 14px;
  font-family: inherit;
  color: var(--black);
  resize: none;
  overflow-y: auto;
}
.native-textarea:focus {
  outline: 1px solid var(--purple);
}
.native-textarea::-webkit-scrollbar {
  display: none;
}
.actionIcons{
  margin-right: 15px;
}
.marginTop15P{
  margin-top: 15px;
}
.saveBttnPadding{
  padding: 0px 20px;
}
.shareProductImg{
  margin: 10px 15px 10px 0px;
}
.custom-table-header{
  padding: 10px;
}

.crm {
  .align-right{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .modal-header{
    font-size: 18px;
    font-style: normal;
    color: var(--black);
    font-weight: 400;
    line-height: 20px;
  }
  .flexText{
    flex: 1;
  }
  .sctn-input {
    font-size: 14px;
  }
  .paddingBottom {
    padding-bottom: 0px;
  }
  .cust-margin{
    margin-top: 0px;
  }
  .genderIcon{
    color: var(--black);
    width: 20px;
    flex-shrink: 0;
  }
  .bttnMargin {
    padding: 15px;
  }
  .list-container {
    padding: 0;
    padding-bottom: 10px;
  }
  .filterAssigned .img-sections {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid #D9DCE3;
    padding: 4px 4px 1px 4px;
  }
  .filterAssigned .img-sections img{
    width: 25px;
    height: 25px;
  }
  .edit-customer-list{
    padding: 15px;
    display: flex;
    margin-bottom: 0px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--background-primary);
  }

  .customer-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
  }
  .infoContainer {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
  }
  .dob_icon{
    right: 25px;
  }
  .allAccordians {
    display: flex;
    gap: 20px;
    .customerDetails {
      width: 100%;
    }
    .extras {
      flex: 0 0 65%;
    }
  }
  .accordion-container{
    border-radius: 5px;
    background: var(--white);
    margin-bottom: 20px;
  }
}
.channel-row {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  align-items: center;
}
.channel-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.channel-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.channel-name {
  font-size: 14px;
  font-weight: 500;
}
.channel-actions {
  display: flex;
  align-items: center;
}
.optionsBttn.resolving {
  opacity: 0.6;
  cursor: not-allowed !important;
}
.optionsBttn.resolving .text {
  color: var(--gray-04);
}
.optin-status-tag{
  padding: 5px 10px;
  -webkit-border-radius: 20px;
  border-radius: 20px;
  font-size: 14px;
}
.optin-status-tag.optin-nostatus{
  background-color: #EDEDED;
  color: #54575E;
}
.optin-status-tag.optin-subscribed{
  background-color: #EAFDF2;
  color: #2DD36F;
}
.optin-status-tag.optin-unsubscribed{
  background-color: #FEE3DD;
  color: #FA7554;
}
.optin-status-tag img{
  vertical-align: middle;
  margin-right: 3px;
  height: 14px;
  width: auto;
}
.number_container{
  background: var(--purple-opac);
  padding: 4px 8px;
  border-radius: 20px;
}
.gap5P{
  gap: 5px;
}
.flex-between{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.accordion-container{
  background: var(--white);
}
.customerDetails{
  background: var(--white);
  border-radius: 5px;
}
@media only screen and (max-width: 768px) { 
  .shareProductView{
    padding: 0px 20px 20px 20px;
  }
  .header.liveChat {
    position: sticky;
    top: 50px;
  }
  .customer-info{
    flex: none;
    height: calc(100% - 100px);
  }
}
</style>